import FormErrorMessage from '@components/FormErrorMessage';
import PlacingOrderView from '@components/PlacingOrderView';
import { ButtonType } from '@components/Button';
import { formatSumWithCurrency } from '@utils/formatValues';
import { IDisposalProcessingModalWindowProps } from '../types';
import { sendDisposalOrder } from '@api/apiClient/returns';
import { TPlacingOrderListItem, TPlacingOrderViewData } from '@components/PlacingOrderView/types';
import { useMemo } from 'react';
import { useMutation } from 'react-query';
import { useProfile } from '@contexts/ProfileContext';
import { useTranslation } from 'react-i18next';

const DisposalProcessingModalWindow: React.FC<IDisposalProcessingModalWindowProps> = (props: IDisposalProcessingModalWindowProps): React.ReactElement => {
  const {
    handlerOnCloseDisposalProcessing,
    handlerRefreshData,
    parcelsGood,
    selectedSumCny,
    selectedSumRub
  } = props;

  const { account } = useProfile();
  const { t } = useTranslation();

  const variableCurrency: string = account?.region === 'TR' ? '$' : '¥';

  const placingOrderViewData: TPlacingOrderViewData = useMemo(() => {
    const condition: boolean = parcelsGood!.length > 1;
    return {
      points: condition ? [
        {
          cols: [
            {
              title: t('disposalOrder.pointListItem1'),
              value: parcelsGood!.length
            },
            {
              title: t('disposalOrder.pointListItem2'),
              value: [formatSumWithCurrency(selectedSumRub, '₽'), formatSumWithCurrency(selectedSumCny, variableCurrency)]
            }
          ]
        }
      ] : undefined,
      title: condition ? t('disposalProcessingModalWindow.title2') : t('disposalProcessingModalWindow.title1')
    };
  }, [parcelsGood]);

  const {
    error: errorSendDisposalOrder,
    isError: isErrorSendDisposalOrder,
    isLoading: isLoadingSendDisposalOrder,
    mutate: mutateSendDisposalOrder
  } = useMutation({
    mutationFn: sendDisposalOrder,
    onSuccess() {
      handlerOnCloseDisposalProcessing();
      handlerRefreshData();
    }
  });

  return (
      <>
        <PlacingOrderView
            buttons={[
              {
                action: handlerOnCloseDisposalProcessing,
                disabled: isLoadingSendDisposalOrder,
                text: t('disposalProcessingModalWindow.cancel'),
                type: ButtonType.SKELETON
              }, {
                action: () => mutateSendDisposalOrder({
                  customerReturnIds: parcelsGood!.map((item: TPlacingOrderListItem) => item.id)
                }),
                disabled: isLoadingSendDisposalOrder,
                text: t('disposalProcessingModalWindow.dispose'),
                type: ButtonType.BLOCK
              }
            ]}
            parcelsGood={parcelsGood}
            placingOrderViewData={placingOrderViewData}
        />
        {isErrorSendDisposalOrder && <FormErrorMessage error={errorSendDisposalOrder}/>}
      </>
  );
};

export default DisposalProcessingModalWindow;